<template>
  <div class="collectionNav" :style="navStyle">
    <NavTop
      :locale="locale"
      :lang="lang"
      :pageId="pageId"
      :categoryId="categoryId"
      :isMainPage="isMainPage"
      :setting="setting" />
    <MyCollectionCategory v-if="isMyCollection"
      :locale="locale"
      :lang="lang"
      :pageId="pageId"
      :categoryId="categoryId"
      :setting="setting" />
    <Category v-else
      :locale="locale"
      :lang="lang"
      :pageId="pageId"
      :categoryId="categoryId"
      :setting="setting"
      :isMainPage="isMainPage" />
  </div>
</template>

<script>
import Category from './Category'
import MyCollectionCategory from './MyCollectionCategory.vue'
import NavTop from './NavTop'

export default {
  name: 'CollectionNav',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId',
    'isMainPage'
  ],
  components: {
    NavTop,
    Category,
    MyCollectionCategory
  },
  computed: {
    setting () {
      return this.$store.getters['collection/getCollectionNavSetting']
    },
    isMyCollection () {
      return this.$route.name === 'myCollection'
    },
    navStyle () {
      const setting = this.setting
      const category = setting && setting.category
      const fontFamily = (category && category.fontFamily && `${category.fontFamily.default}, ${category.fontFamily.default2}, ${category.fontFamily.default3}`) || ''
      function spacingToLts (spacing) {
        const numeric = parseFloat(spacing)
        if (isNaN(numeric)) return null // 유효하지 않은 입력 처리
        return (numeric / 1000).toFixed(2)
      }
      return {
        color: category && category.text && category.text.color,
        letterSpacing: `${spacingToLts(category && category.text && category.text.spacing)}em`,
        fontSize: `${category && category.text && category.text.size}px`,
        fontFamily: fontFamily
      }
    }
  }
}
</script>